<script>
export default {
  props: {
    hiveBot: Object,
    picker: Boolean
  },

  data: function() {
    return {
      flagDeploy: false,
      activeConfirmDialog: false
    }
  },

  created: function() {
    this.$emit('buttons', this.buttons)
  },

  beforeDestroy: function() {
    this.$emit('buttons', null)
  }
}
</script>

<template>
  <div>
    <v-toolbar dense color="secondary">
      <v-toolbar-title class="body-2 beez-bold "
        >{{ hiveBot.className }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card>
      <div class="pa-4">
        <v-text-field
          label="Class Name"
          color="secondary"
          v-model="hiveBot.className"
          required
          :disabled="picker"
        >
        </v-text-field>
      </div>
    </v-card>
  </div>
</template>
